import React, { useState, useEffect } from 'react';
import axios from 'axios'
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import color from 'color'
import RankCard from './RankCard';
import WelcomeCard from './WelcomeCard';
import ScholarshipCard from './ScholarshipCard';
import CountTree from './CountTree';
import Alert from '@mui/material/Alert';
import { api_url } from '../config';
import Footer from '../Footer';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

// const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
//   ({ theme, open }) => ({
//     '& .MuiDrawer-paper': {
//       position: 'relative',
//       whiteSpace: 'nowrap',
//       width: drawerWidth,
//       transition: theme.transitions.create('width', {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.enteringScreen,
//       }),
//       boxSizing: 'border-box',
//       ...(!open && {
//         overflowX: 'hidden',
//         transition: theme.transitions.create('width', {
//           easing: theme.transitions.easing.sharp,
//           duration: theme.transitions.duration.leavingScreen,
//         }),
//         width: theme.spacing(7),
//         [theme.breakpoints.up('sm')]: {
//           width: theme.spacing(9),
//         },
//       }),
//     },
//   }),
// );

const mdTheme = createTheme();

function DashboardContent(props) {
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };
  const { setToken } = props
  const { token } = props;
  const { fetch } = props;
  const { val } = props;
  const { result } = props;


  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="absolute" open={open}>
          <Toolbar
            sx={{
              pr: '24px', // keep right padding when drawer closed
            }}
            style={{ backgroundColor: '#2a7e19' }}
          >
            {/* <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                marginRight: '36px',
                ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon />
            </IconButton> */}
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              Mission Vriksh
            </Typography>
            <IconButton color="inherit" onClick={() => {
              setToken(null)
            }
            }>
              <PowerSettingsNewIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        {/* <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              px: [1],
            }}
          >
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>
          <Divider />
        </Drawer> */}
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />


          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>

            <Grid container spacing={6} style={{ justifyContent: 'space-between' }}>


              <Grid item xs={12} md={6} lg={4}>
                <Paper
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '300px',
                  }}
                  style={{ backgroundColor: color('#7E9B24').lighten(1.5) }}
                >
                  <WelcomeCard {...props} token={token} fetch={fetch} />
                </Paper>
              </Grid>

              <Grid item xs={12} md={4} lg={4}>
                <Paper
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    height: 'auto',
                    width: 'auto'
                  }}
                  style={{ backgroundColor: color('#7E9B24').lighten(1.5) }}
                >
                  <ScholarshipCard result={result} {...props} />
                </Paper>
              </Grid>

              <Grid item xs={12} md={4} lg={4}>
                <Paper
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    height: 'auto',
                    width: 'auto'
                  }}
                  style={{ backgroundColor: color('#7E9B24').lighten(1.5) }}
                >
                  <CountTree {...props} type={"Dashboard"} token={token} />
                </Paper>
              </Grid>


            </Grid>
            <br />
            <br />



            {(val === 0)
              ? <>
              </>
              : <>
                <Alert severity='success' style={{ textAlign: 'center' }}><Typography style={{ textAlign: 'center' }} variant="h5">View all yours Planted Trees Here</Typography></Alert>

                <br />
                <Grid container spacing={3}>
                  {val.map((ele, i) => (
                    <Grid item xs={12} md={4} lg={4}>
                      <Paper
                        sx={{
                          p: 2,
                          display: 'flex',
                          flexDirection: 'column',
                          height: 'auto',
                        }}
                        style={{ backgroundColor: color('#7E9B24').lighten(1.5) }}
                      >
                        <RankCard fetch={fetch} is_image1_uploaded={ele.is_image1_uploaded} is_image2_uploaded={ele.is_image2_uploaded} is_image3_uploaded={ele.is_image3_uploaded} is_image4_uploaded={ele.is_image4_uploaded} is_image5_uploaded={ele.is_image5_uploaded} tree_id={ele.data} {...props} token={token} />
                      </Paper>
                    </Grid>

                  ))}
                </Grid>
              </>
            }




          </Container>
        </Box>
      </Box>
      <Footer />
    </ThemeProvider>
  );
}

export default function Dashboard({ token, setToken }) {

  const [res, setRes] = useState([]);
  const [load, setLoad] = useState(false);
  const [val, setVal] = useState([]);
  const [result, setResult] = useState([]);

  useEffect(async () => {

    fetch();
  }, [])

  const fetch = async () => {
    try {
      setLoad(true);
      const { data: obj } = await axios({
        url: api_url + '/mission-vriksh-order-details',
        method: 'post',
        responseType: 'json',
        data: {
          id: token,
        },
      })
      if (obj.success === 'ok') {
        setRes(obj.array);
        setVal(obj.que)
        setResult(obj.result);
      }
      else {
        alert(obj.message);
      }
    }
    catch (e) {
      alert(e.message);
    }
    finally {
      setLoad(false);
    }
  }

  if (load)
    return (<p>Loading...</p>)

  return <DashboardContent fetch={fetch} res={res} val={val} result={result} setToken={setToken} token={token} />;
}